import type { BaseAPIResponse } from '~/types/api';

export interface RapidResponseEscalation {
    exposure_id: string; // UUID string
    status: 'pending' | 'assigned' | 'submitted' | 'finished';
    charge_amount: number;
    escalation_notes?: string;
    assigned_to?: {
        id: number;
        first_name: string;
        last_name: string;
    };
    elapsed_time: string;
    created_at: string;
    assigned_at?: string;
    submitted_at?: string;
    finished_at?: string;
}

export interface CreateEscalationRequest {
    exposure_id: string;
    escalation_notes?: string;
}

class RapidResponseService {
    /**
     * Create a new escalation for an exposure
     */
    async createEscalation(personId: number, escalationData: CreateEscalationRequest): Promise<RapidResponseEscalation> {
        const nuxtApp = useNuxtApp();
        
        try {
            const { data, status, message } = await usePbApi<BaseAPIResponse<RapidResponseEscalation>>(
                nuxtApp.$api.routes.people.exposures.rapid_response.store(personId),
                {
                    method: 'POST',
                    body: escalationData,
                }
            );

            if (status !== 201) {
                throw new ApiError(message || 'Failed to create escalation', status);
            }


            return data?.data!;
        } catch (error: any) {
            throw ApiError.fromFetchError(error);
        }
    }
}

export const rapidResponseService = new RapidResponseService();
